module.exports = __webpack_public_path__ + "static/media/entregarinju.f88b838b.jpg";